import React from 'react';
import { observer } from 'mobx-react-lite';
import { Progress } from 'antd';
import chatStore from '../stores/chatStore';
import { useTheme } from '../theme/ThemeContext';

function formatBytes(n) {
    if (!n && n !== 0) return '';
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

const FileChip = observer(({ item }) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <div
            className={`relative flex w-[180px] items-center gap-2 rounded-xl border p-2 ${
                isDark ? 'border-white/10 bg-white/5' : 'border-black/10 bg-white'
            }`}
        >
            {item.previewUrl ? (
                <img src={item.previewUrl} alt="" className="h-10 w-10 rounded-md object-cover" />
            ) : (
                <div
                    className={`flex h-10 w-10 items-center justify-center rounded-md text-[10px] font-semibold ${
                        isDark ? 'bg-white/10' : 'bg-black/5'
                    }`}
                >
                    {(item.kind || '').includes('audio') || (item.mime || '').startsWith('audio/')
                        ? 'AUD'
                        : 'FILE'}
                </div>
            )}
            <div className="min-w-0 flex-1">
                <div className="truncate text-xs font-medium">{item.name}</div>
                <div className="text-[10px] opacity-60">
                    {formatBytes(item.size)}
                    {item.status === 'ready'
                        ? ' · готово'
                        : item.status === 'uploading'
                          ? ' · загрузка'
                          : item.status === 'error'
                            ? ' · ошибка'
                            : ` · ${item.status}`}
                </div>
                {(item.status === 'uploading' || item.status === 'processing') && (
                    <Progress percent={item.percent || 0} size="small" showInfo={false} />
                )}
                {item.status === 'error' && (
                    <button
                        type="button"
                        className="text-[10px] text-red-500 underline"
                        onClick={() => {
                            chatStore.removeAttachment(item.localId);
                            chatStore.uploadAttachment(item.file);
                        }}
                    >
                        Повторить
                    </button>
                )}
            </div>
            <button
                type="button"
                className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-black/70 text-[10px] text-white"
                onClick={() => chatStore.removeAttachment(item.localId)}
            >
                ×
            </button>
        </div>
    );
});

export default FileChip;
